// German for the confirm dialogue's two fixed verbs (same values as the shared vocabulary).
import { registerDe } from '../i18n/index.js';

registerDe({
  'Cancel': 'Abbrechen',
  'Confirm': 'Bestätigen',
}, 'ConfirmModal');
